import { Point } from 'highcharts';
import i18next from 'i18next';
import { bankersRound } from '@components-clean/core/charts/shared/number-utils';
import chartStyles from '@components-clean/core/charts/shared/style.module.scss';
import { FilterUIStateUpdate } from '@components-clean/core/filter-ui/action-bar/shared/interfaces';

const mergeTrackedChanges = (
    clickTrackedChanges: FilterUIStateUpdate[],
    screenTrackedChanges: FilterUIStateUpdate[],
): FilterUIStateUpdate[] => {
    const clickFieldKeys = new Set(clickTrackedChanges.map((change) => change.fieldKey));
    const remainingScreenChanges = screenTrackedChanges.filter((change) => !clickFieldKeys.has(change.fieldKey));
    return [...clickTrackedChanges, ...remainingScreenChanges];
};

const convertRiskRatingToRiskLogScoreColour = (trackedChanges: FilterUIStateUpdate[]): FilterUIStateUpdate[] =>
    trackedChanges.map((change) =>
        change.fieldKey === 'riskRating'
            ? {
                  ...change,
                  fieldKey: 'score',
                  valueKey: 'colour',
                  uncheckedValues: change.uncheckedValues.map((value) =>
                      value === i18next.t('ram:riskLog.riskRating.NONE') ? null : value,
                  ),
              }
            : change,
    );

export const appendScreenFiltersQuery = (
    path: string,
    clickTrackedChanges: FilterUIStateUpdate[],
    screenTrackedChanges: FilterUIStateUpdate[],
    includeObsolete: boolean,
): string => {
    const trackedChanges = convertRiskRatingToRiskLogScoreColour(
        mergeTrackedChanges(clickTrackedChanges, screenTrackedChanges),
    );

    const params = new URLSearchParams();
    if (trackedChanges.length) params.set('trackedChanges', JSON.stringify(trackedChanges));
    if (includeObsolete) params.set('includeObsolete', 'true');

    const query = params.toString();
    if (!query) return path;

    const separator = path.includes('?') ? '&' : '?';
    return `${path}${separator}${query}`;
};

export const stackedChartTooltipFormatter = (point: Point, xAxisTotals: Record<number, number>) =>
    [
        `<b>${point.key}</b>`,
        `# Risks: ${point.y}`,
        `Percentage: ${bankersRound((point.y! / xAxisTotals[point.x]) * 100, 2)}%`,
        `RAG: ${point.series.name}`,
    ].join('<br/>');

export const stackedChartSeriesColours = [
    chartStyles['rag-colour-red'],
    chartStyles['rag-colour-amber'],
    chartStyles['rag-colour-green'],
];
